module.exports = __webpack_public_path__ + "img/reduced_size_gif.0b4238d3.jpg";